/**
 * @file PagePublicationsHost.tsx
 * @description Окна черновика страницы в конструкторе (phase19.16 Р3а;
 * uiux-r3 §3.1): шторка «Публикации» (до 1280), «Все версии», «Вернуть
 * версию N» и «Удалённые страницы». Состояние — `usePublicationsUi`.
 */

import { useBuilder } from "../builder-context";
import { DeletedPagesDialog } from "../dialogs/DeletedPagesDialog";
import { PagePublicationsSheet } from "./PagePublicationsSheet";
import { PageRollbackDialog } from "./PageRollbackDialog";
import { PageVersionsDialog } from "./PageVersionsDialog";
import type { PublicationsUi } from "../../../hooks/site-builder/usePublicationsUi";

export function PagePublicationsHost({ ui }: { ui: PublicationsUi }) {
  const b = useBuilder();
  return (
    <>
      <PagePublicationsSheet open={ui.publicationsOpen} onClose={ui.closePublications} />
      <PageVersionsDialog open={ui.versionsOpen} onClose={ui.closeVersions} onRollback={ui.openRollback} />
      <PageRollbackDialog
        version={ui.rollbackVersion}
        onClose={ui.closeRollback}
        onDone={() => {
          ui.closeRollback();
          ui.closeVersions();
          // Просмотр версии на канве — закрыть: на сайте уже возвращённая версия.
          if (b.override?.pageVersion) b.setOverride(null);
        }}
      />
      <DeletedPagesDialog open={ui.deletedOpen} onClose={ui.closeDeletedPages} />
    </>
  );
}
